import React, {useContext, useState} from "react"
import PropTypes from "prop-types";
import Loading from "components/Loading";
import FormTranslationContext from "context/FormTranslationContext";
import {Table, TableBody, TableHead, TableRow, Tooltip} from "@material-ui/core";
import AnnualReportTableCell from "../common/AnnualReportTableCell";
import Tr from "translations/Translations";
import AnnualReportEditPopup from "../common/AnnualReportEditPopup";
import AnnualReportCommunityEditForm from "./AnnualReportCommunityEditForm";
import annualReportSteps from "../../constants/annualReportSteps";
import MoveAnnualReportEntry from "../common/MoveAnnualReportEntry";
import AnnualReportTablePart from "../common/AnnualReportTablePart";
import AnnualReportSearchBar from "../common/AnnualReportSearchBar";
import formatAmountNumber from "libs/formatAmountNumber";
import formatBoolean from "libs/formatBoolean";
import formatInteger from "libs/formatInteger";
import AnnualReportTableHeadCell from "../common/AnnualReportTableHeadCell";
import annualReportTenderMode from "../../constants/annualReportTenderMode";

const columns = ["number", "source", "noticeNumber", "serviceDescription", "codeCpv", "tenderModeBzp", "reservedTender", "amount",
    "numberOfAwardedLots", "numberOfOffers", "numberOfOffersMMSP"];
const reportStep = annualReportSteps.community;

function AnnualReportCommunityForm(
    {
        initValues,
        classes,
        disabled
    }
) {
    const {getDict, dictTranslations} = useContext(FormTranslationContext);
    const [types] = useState(getDict("MP.MMiA.OrdersType").filter(item => item.value !== "DEFENSE_AND_SECURITY"));
    const [editPopup, setEditPopup] = useState(null);
    const [movePopup, setMovePopup] = useState(null);
    const [search, setSearch] = useState({search: ""});

    const getRowValues = (entry) => ([
        entry.number,
        entry.source ? dictTranslations.source[entry.source] : null,
        entry.noticeNumber,
        entry.serviceDescription,
        entry.codeCpv ? <Tooltip title={entry.codeCpv.name}><span>{entry.codeCpv.publicCode}</span></Tooltip> : null,
        annualReportTenderMode(entry, dictTranslations),
        formatBoolean(entry.reservedTender),
        formatAmountNumber(entry.amount),
        formatInteger(entry.numberOfAwardedLots),
        formatInteger(entry.numberOfOffers),
        formatInteger(entry.numberOfOffersMMSP),
    ])

    if (!initValues) return <Loading/>
    return <>
        <AnnualReportSearchBar reportStep={reportStep} setSearch={setSearch} classes={classes} disabled={disabled} setEditPopup={setEditPopup}/>

        <Table>
            <TableHead>
                <TableRow className={classes.tableMainHeaderRow}>
                    {columns.map(x => (<AnnualReportTableHeadCell key={x} label={`mmia.${reportStep}.${x}`}/>))}
                    <AnnualReportTableCell borderLeft borderRight colSpan={2}></AnnualReportTableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {
                    types.map((type) =>
                        <AnnualReportTablePart
                            key={type.value}
                            classes={classes}
                            type={type.value}
                            reportStep={reportStep}
                            partName={dictTranslations.type[type.value]}
                            disabled={disabled}
                            entries={initValues[type.value]}
                            search={search}
                            setEditPopup={setEditPopup}
                            setMovePopup={setMovePopup}
                            columnCount={columns.length}
                            getRowValues={getRowValues}
                        />
                    )
                }
            </TableBody>

        </Table>

        {
            !!editPopup &&
            <AnnualReportEditPopup
                onClose={() => setEditPopup(null)}
                config={editPopup}
                reportStep={annualReportSteps.community}
                FormComponent={AnnualReportCommunityEditForm}
            />
        }
        {
            !!movePopup &&
            <MoveAnnualReportEntry
                items={types.filter((item) => item.value !== movePopup.currentType)}
                onClose={() => setMovePopup(null)}
                inputLabel={Tr("order_type")}
                reportStep={reportStep}
                config={movePopup}
            />
        }
    </>
}

AnnualReportCommunityForm.prototype = {
    initValues: PropTypes.object.isRequired,
    disabled: PropTypes.bool.isRequired,
    classes: PropTypes.object.isRequired
}

export default AnnualReportCommunityForm;